import React, { useEffect, useState, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import "../MainBox.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import ReprintDelete from "../reprintDeleteWarningPopUp";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from 'react-datepicker';
import PRHLoader from "../../lib/PRHLoader";
import OIDatePicker from "./PrintBindDate";

const formatInputNumber = (data) => {
    if (data == null) { return ''; }
    if (data == 0) { return 0; }
    var value = data.toString().replace(/,/g, '');
    if (!value || isNaN(value.toString())) { return ''; }
    var sansDec = Number(value).toFixed(0);
    var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatted;
}

export default function ReprintsInputUS(props) {
    const [reprint, setReprint] = useState(null);
    const [rpntKey, setRpntKey] = useState(false);
    const [addtnlRpntKey, setAddtnlRRpntKey] = useState(false);
    const [reprintLoading, setreprintLoading] = useState(false);
    const [reprintUpdating, setReprintUpdating] = useState(false);
    const [reprintActive, setreprintActive] = useState(false);
    const [reprintActiveCVR, setreprintActiveCVR] = useState(false);
    const [additionalCVRReprint, setAdditionalCVRReprint] = useState(null);
    const [managerOptions, setManagerOptions] = useState([]);
    const [sLocOptions, setSLocOptions] = useState([]);
    const [VersionOptions, setVersionOptions] = useState([]);
    const [BatchCode, setBatchCode] = useState([]);
    const [shouldUpdate, setShouldUpdate] = useState(false);
    const [selectedOption, setselectedOption] = useState([]);
    const timeoutId = useRef(null);
    const timeoutIdPrice = useRef(null);
    const timeoutIdAddtitionalCVR = useRef(null);
    const datePicker1 = useRef(null);
    const datePicker2 = useRef(null);
    const [c005_AdditionalRow, setC005_AdditionalRow] = useState(false);

    function onOptionSelect(e) {
        if (e && e.length > 0) {
            setReprint(prev => ({ ...prev, c005_ProductionManager: e[0] }));
            if (!shouldUpdate)
                setShouldUpdate(true);
            setselectedOption(e);
        }
    }
   
       
        

    const handleChange = (e) => {
        const { name, value } = e.target;
        var data;
        if (name == "c005_PrintBindDate") {
            if (value == null || validateDate(value)) {
                data = value;
            } else return;
        }
        else if (name == "c005_CoverDelDate") {
            if (value == null || validateDate(value) || value === "") {
                const dateToSave = new Date(value);
                data = new Date(dateToSave.setHours(0, 0, 0, 0));
            }
            else return;
        } else
            if (name === "c005_PrintBindQty") {
                data = value.replace(/[^0-9]/g, '');
                if (data == null || data == undefined || data == "") {
                return}
                let number = parseInt(data, 10);
                data = number > 5000000 ? 5000000 : (number < 1 ? 1 : number);
            } else if (name === "c005_CoverQty") {
                data = value.replace(/[^0-9]/g, '');
                if (isNaN(data) || data == null || data == undefined || data.trim() == "") {
                    data = 0;
                } else {
                    let number = parseInt(data, 10);
                    data = number > 5000000 ? 5000000 : (number < 0 ? 0 : number);
                }
            } else if (name === "c005_NewUSPrice" || name === "c005_NewCANPrice") {
                let num = parseFloat(parseFloat(value).toFixed(2));
                data = num > 5000 ? 5000000 : (num < 0 ? 0 : num);
            }
            else data = value;

        if (name === "c005_NewUSPrice" || name === "c005_NewCANPrice") {
            setShouldUpdate(false);
            if (reprint?.c005_BatchCode == null || reprint?.c005_BatchCode === "") {
                setReprint(prev => ({ ...prev, c005_BatchCode: "R" }));
            }
            getPrice(data, name === "c005_NewUSPrice" ? true : false, name);
        } 
        else {
            setReprint(prev => ({ ...prev, [name]: data }));
            if (!shouldUpdate)
                setShouldUpdate(true);
        }
    }

    const getPrice = (value, IsUsPrice, name) => {
        setReprint(prev => ({ ...prev, [name]: value }));
        clearTimeout(timeoutIdPrice.current);
        timeoutIdPrice.current = setTimeout(() => {
            getPriceCall(value, IsUsPrice, name);
        }, 1000);
    }

    const getPriceCall = async (value, IsUsPrice, name) => {
        setShouldUpdate(true);
        const res = await apiHelper.inventoryPostCall("getPrice", {
            Price: value,
            IsUSPrice: IsUsPrice,
            ISBN: props.ISBNId
        })
        const dataName = name === "c005_NewUSPrice" ? "c005_NewCANPrice" : "c005_NewUSPrice";
        setReprint(prev => ({ ...prev, [dataName]: res }));
    }

    const handleAddtionalCVRChange = (e) => {
        const { name, value } = e.target;
        var data;
        if (name == "c005_PrintBindDate") {
            if (validateDate(value) || value == null) {
                data = value;
            } else return;
        }
        else if (name == "c005_CoverDelDate") {
            if (validateDate(value) || value === "") {
                const dateToSave = new Date(value);
                data = new Date(dateToSave.setHours(0, 0, 0, 0));
            }
            else return;
        } else
            if (name === "c005_PrintBindQty") {
                data = value.replace(/[^0-9]/g, '');
                let number = parseInt(data, 10);
                data = number > 5000000 ? 5000000 : (number < 1 ? 1 : number);
            } else if (name === "c005_CoverQty") {
                data = value.replace(/[^0-9]/g, '');
                let number = parseInt(data, 10);
                data = number > 5000000 ? 5000000 : (number < 0 ? 0 : number);
            }
            else data = value;
        setAdditionalCVRReprint(prev => ({ ...prev, [name]: data }));
        if (!shouldUpdate)
            setShouldUpdate(true);
    }

    const fetchData = async (id) => {
        try {
            if (managerOptions.length < 0)
                await getListData();
            if (id) {
                setreprintLoading || reprintUpdating(true);
                const data = await apiHelper.inventoryPostCall("getReprintsUS", { value: id });
                if (data?.reprintsData != undefined && data?.reprintsData != null) {
                    const newData = {
                        ...data.reprintsData,
                        c005_Changes: data.reprintsData.c005_Changes && data.reprintsData.c005_Changes == 'X' ? true : false, c005_HP: data.reprintsData.c005_HP && data.reprintsData.c005_HP == 'X' ? true : false,
                        c005_RI: data.reprintsData.c005_RI && data.reprintsData.c005_RI == 'X' ? true : false,
                        c005_PrintAhead: data.reprintsData.c005_PrintAhead && data.reprintsData.c005_PrintAhead == 'X' ? true : false
                    }
                    const reprintUpdatedData = {
                        ...newData,
                        c005_ProductionManager: (data.reprintsData?.c005_ProductionManager !== undefined && data.reprintsData?.c005_ProductionManager !== "" && data.reprintsData?.c005_ProductionManager !== null)
                            ? data.reprintsData.c005_ProductionManager
                            : ((props?.metaData?.productionManager !== undefined && props?.metaData?.productionManager !== "" && props?.metaData?.productionManager !== null)
                                ? props.metaData.productionManager
                                : null),
                        c005_Version: (data.reprintsData?.c005_Version !== undefined && data.reprintsData?.c005_Version != null && data.reprintsData?.c005_Version !== "")
                            ? data.reprintsData.c005_Version
                            : (props?.metaData?.version !== undefined && props?.metaData?.version !== "" && props?.metaData?.version !== null)
                                ? props.metaData.version
                                : null,
                        Sloc: (data.reprintsData?.sloc !== undefined && data.reprintsData?.sloc !== "" && data.reprintsData?.sloc !== null)
                            ? data.reprintsData.sloc
                            : (props?.metaData?.sloc !== undefined && props?.metaData?.sloc !== "" && props?.metaData?.sloc !== null)
                                ? props.metaData.sloc
                                : null,
                    }

                    setReprint(reprintUpdatedData);
                    setselectedOption((data.reprintsData?.c005_ProductionManager !== undefined && data.reprintsData?.c005_ProductionManager !== "" && data.reprintsData?.c005_ProductionManager !== null)
                        ? [data.reprintsData.c005_ProductionManager]
                        : ((props?.metaData?.productionManager !== undefined && props?.metaData?.productionManager !== "" && props?.metaData?.productionManager !== null)
                            ? [props?.metaData?.productionManager]
                            : []));
                } else {
                    setReprint({
                        c005_ProductionManager: (props?.metaData?.productionManager !== undefined && props?.metaData?.productionManager !== "" && props?.metaData?.productionManager !== null)
                            ? props?.metaData?.productionManager
                            : null,
                        c005_Version: (props?.metaData?.version !== undefined && props?.metaData?.version !== "" && props?.metaData?.version !== null)
                            ? props.metaData.version
                            : null,
                        Sloc: (props?.metaData?.sloc !== undefined && props?.metaData?.sloc !== "" && props?.metaData?.sloc !== null)
                            ? props.metaData.sloc
                            : null,
                    });
                    const selectedoptn = (props?.metaData?.productionManager != undefined && props?.metaData?.productionManager != "" && props?.metaData?.productionManager != null) ? [props?.metaData?.productionManager] : [];
                    setselectedOption(selectedoptn);
                }
                if (data?.reprintsCVRData != undefined && data?.reprintsCVRData != null) {
                    setAdditionalCVRReprint(data?.reprintsCVRData);
                    setC005_AdditionalRow(true);
                } else {
                    setAdditionalCVRReprint(null);
                }
            }
        } catch (error) {
            console.error("Error at fetch forecast " + error);
        } finally {
            setreprintLoading || reprintUpdating(false);
        }
    }

    const getListData = async () => {
        try {
            const data = await apiHelper.inventoryPostCall("getReprintsData");
            if (data) {
                if (data.productionmanager) {
                    setManagerOptions(data.productionmanager.map(i => i.prodManager).filter(Boolean));
                }
                if (data.batchCode)
                    setBatchCode(data.batchCode);
                if (data.getSloc) {
                    const filteredSLoc = data.getSloc.filter(i => i.sloc !== null);
                    filteredSLoc.push({ sloc: "EXT" });
                    setSLocOptions(filteredSLoc);
                }
                if (data.getVersion)
                    setVersionOptions(data.getVersion);
            }
        } catch (e) {
            console.error(e);
        }
    }
    const handleCheckBoxChange = (e) => {
        const { name, checked } = e.target;
        setReprint(prev => ({ ...prev, [name]: checked }));
        if (!shouldUpdate)
            setShouldUpdate(true);
    }
    const handleAdditionalCvrChk = (e) => {
        if (!e.target.checked) {
            setreprintActiveCVR(prev => !prev);
        } else {
            setC005_AdditionalRow(e.target.checked);
            if (!(additionalCVRReprint?.c005_PrintBindQty != null && additionalCVRReprint?.c005_PrintBindQty != "")) {
                setAdditionalCVRReprint({ ...additionalCVRReprint, c005_PrintBindDate: "2044-04-04", c005_PrintBindQty:1 });
                setShouldUpdate(true);
                submitAdditionalCVRData();
            }
        }
    }

    const onCloseCVR = () => {
        setreprintActiveCVR(prev => !prev);
        setC005_AdditionalRow(true);
    }

    const onClose = () => {
        setreprintActive(prev => !prev);
    }

    const deleteReprint = async (cvr) => {
        try {
            if (cvr) {
                setAddtnlRRpntKey(true);
            } else {
                setRpntKey(true);
            }
            const res = await apiHelper.inventoryPostCall("deleteRerpint", { ISBN: props.ISBNId, cvrjckt: cvr });
            if (res && !cvr) {
                const res2 = await apiHelper.inventoryPostCall("deleteRerpint", { ISBN: props.ISBNId, cvrjckt: !cvr });
                if (res2)
                    setC005_AdditionalRow(false);
            }
            if (res) {
                fetchData(props.ISBNId);
            }
            if (cvr) {
                setC005_AdditionalRow(false);
                setreprintActiveCVR(prev => !prev);
            }
            else onClose();

        } catch (e) {
            console.error(e);
        } finally {
            if (cvr) {
                setAddtnlRRpntKey(false);
            } else {
                setRpntKey(false);
            }
        }
    }
    useEffect(() => {
        if (shouldUpdate) {
            submitData();
        }
    }, [reprint])

    useEffect(() => {
        if (shouldUpdate && c005_AdditionalRow) {
            submitAdditionalCVRData();
        }
    }, [additionalCVRReprint])

    useEffect(() => {
        setselectedOption([]);
        setShouldUpdate(false);

        if (props.ISBNId) {
            setAdditionalCVRReprint(null);
            setC005_AdditionalRow(false);
            setselectedOption([]);
            setReprint(prev => ({ ...prev, c005_ProductionManager: [] }));
            fetchData(props.ISBNId);
        }

    }, [props.metaData]);

    const validateDate = (dateString) => {
        if (!dateString)
            return false;
        var date = new Date(dateString);
        if (isNaN(date.getTime())) return false;
        else {
            var minYear = 1900;
            var maxYear = new Date().getFullYear() + 100; // Allow up to 10 years into the future
            var year = date.getFullYear();
            if (year > minYear && year < maxYear) { return true; }
        }
    }

    const submitData = () => {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(() => {
            callUpdate();
        }, 1000);
    }

    const callUpdate = async () => {
        const res = await UpdateCall();
        if (res == true && c005_AdditionalRow) {
            submitAdditionalCVRData();
        }
        else {
            await setShouldUpdate(false);
            //   fetchData(props.ISBNId);
        }

    }
    const submitAdditionalCVRData = () => {
        clearTimeout(timeoutIdAddtitionalCVR.current);
        timeoutIdAddtitionalCVR.current = setTimeout(() => {
            UpdateAdditionalCVRCall();
        }, 1000);
    }

    const UpdateCall = async () => {
        if (
            props.upn != null
            && props.upn != ""
            && props.ISBNId != null
            && props.ISBNId != ""
            && ((reprint?.c005_PrintBindQty != null
                && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments.trim() != ""))
        ) {
            try {
                const cvrQty = reprint?.c005_PrintBindQty;
                setReprintUpdating(true);
                titleAlert("Updating Forecast Reprints...", "update", 'alert-reprint-update');
                const payload = {
                    C005_UPN: props?.upn,
                    C005_ISBN: reprint?.c005_ISBN ?? props?.ISBNId,
                    C005_PrintBindQty: reprint?.c005_PrintBindQty,
                    C005_PrintBindDate: (reprint?.c005_PrintBindDate != "" && reprint?.c005_PrintBindDate != null) ? toDateOnlyString(reprint?.c005_PrintBindDate) : null,
                    C005_CoverQty: isNaN(reprint?.c005_CoverQty) ? reprint?.c005_PrintBindQty : reprint.c005_CoverQty,
                    C005_CoverDelDate: (reprint.c005_CoverQty != null && reprint.c005_CoverQty != "" && reprint.c005_CoverQty > 0) ? toDateOnlyString(reprint.c005_CoverDelDate) : null,
                    C005_NewUSPrice: (reprint?.c005_NewUSPrice != null && reprint.c005_NewUSPrice != "") ? reprint.c005_NewUSPrice : null,
                    C005_NewCANPrice: (reprint?.c005_NewCANPrice != null && reprint.c005_NewCANPrice != "") ? reprint.c005_NewCANPrice : null,
                    C005_BatchCode: reprint?.c005_BatchCode ?? null,
                    C005_Comments: (reprint?.c005_Comments != null && reprint.c005_Comments != "") ? reprint.c005_Comments : null,
                    C005_Changes: reprint.c005_Changes ?? false,
                    C005_HP: reprint?.c005_HP ?? false,
                    C005_RI: reprint?.c005_RI ?? false,
                    C005_PrintAhead: reprint?.c005_PrintAhead ?? false,
                    C005_ProductionManager: reprint?.c005_ProductionManager != null && reprint?.c005_ProductionManager.length != '' ? reprint?.c005_ProductionManager : null,
                    C005_Version: reprint?.c005_Version ?? null,
                    C005_AdditionalRow: false,//always false to save in database
                    Sloc: reprint?.Sloc ?? null
                }

                const res = await apiHelper.inventoryPostCall("setReprints", payload);
                
                    if (isNaN(reprint.c005_CoverQty)) {
                        setReprint(prev => ({ ...prev, c005_CoverQty: cvrQty }));
                    }
                if (res == true) {

                    await setShouldUpdate(false);
                    titleAlert("Reprint updated successfully.", "success", 'alert-reprint-update');
                    return true;
                } else { throw new Error("Failed to update reprint"); }
            } catch (error) {
                titleAlert("Update Failed.", "error", 'alert-reprint-update');
                console.error("setReprints api failed", error);
                return false;
            } finally {
                setReprintUpdating(false);
                setTimeout(() => titleAlert('', 'info', 'alert-reprint-update'), 2000);
            }
        }
    }

    const toDateOnlyString = (date) => {
        if (!date || isNaN(new Date(date))) {
            return null; // or null, depending on what backend expects
        }

        if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date; // already YYYY-MM-DD
        }
        const d = new Date(date);
        return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;

    };



    const UpdateAdditionalCVRCall = async () => {
        if (props.upn != null
            && props.upn != ""
            && props.ISBNId != null
            && props.ISBNId != ""
            && (additionalCVRReprint?.c005_ISBN == null
            || ((additionalCVRReprint?.c005_PrintBindQty != null
            && additionalCVRReprint?.c005_PrintBindQty > 0)
            || (additionalCVRReprint?.c005_Comments != null
            && additionalCVRReprint?.c005_Comments.trim() != "")))) {

            try {
                setReprintUpdating(true);
                titleAlert("Updating Additional Cover Data...", "update", 'alert-reprint-update');
                let printBindQty;
                let comments;
                if (additionalCVRReprint?.c005_ISBN != null) {
                    printBindQty = additionalCVRReprint?.c005_PrintBindQty;
                    comments = additionalCVRReprint?.c005_Comments;
                } else {
                    printBindQty = isNaN(additionalCVRReprint?.c005_PrintBindQty) ? 1 : additionalCVRReprint?.c005_PrintBindQty;
                    comments = (additionalCVRReprint?.c005_Comments != null && additionalCVRReprint?.c005_Comments != "") ? additionalCVRReprint.c005_Comments : null;
                }
                const payload = {
                    C005_UPN: props?.upn,
                    C005_ISBN: props?.ISBNId,
                    C005_PrintBindQty: printBindQty,
                    C005_PrintBindDate: additionalCVRReprint?.c005_PrintBindDate ? toDateOnlyString(additionalCVRReprint?.c005_PrintBindDate) : "2044-04-04" ,
                    C005_CoverQty: isNaN(additionalCVRReprint?.c005_CoverQty) ? 0 : additionalCVRReprint.c005_CoverQty,
                    C005_CoverDelDate: (additionalCVRReprint?.c005_CoverQty != null && additionalCVRReprint?.c005_CoverQty != "" && additionalCVRReprint.c005_CoverQty > 0) ? toDateOnlyString(additionalCVRReprint.c005_CoverDelDate) : null,
                    C005_NewUSPrice: (reprint?.c005_NewUSPrice != null && reprint?.c005_NewUSPrice != "") ? reprint.c005_NewUSPrice : null,
                    C005_NewCANPrice: (reprint?.c005_NewCANPrice != null && reprint?.c005_NewCANPrice != "") ? reprint.c005_NewCANPrice : null,
                    C005_BatchCode: reprint?.c005_BatchCode ?? null,
                    C005_Comments: comments,
                    C005_Changes: reprint.c005_Changes ?? false,
                    C005_HP: reprint?.c005_HP ?? false,
                    C005_RI: reprint?.c005_RI ?? false,
                    C005_PrintAhead: reprint?.c005_PrintAhead ?? false,
                    C005_ProductionManager: reprint?.c005_ProductionManager != null && reprint?.c005_ProductionManager.length != '' ? reprint?.c005_ProductionManager : null,
                    C005_Version: reprint?.c005_Version ?? null,
                    C005_AdditionalRow: true,//always true to save in database as additionalcvr details
                    Sloc: reprint?.Sloc ?? null
                }

                await apiHelper.inventoryPostCall("setReprints", payload);
                await setShouldUpdate(false);
                //  await fetchData(props.ISBNId);
                titleAlert("Additional Cover Reprint updated successfully.", "success", 'alert-reprint-update');
            } catch (error) {
                titleAlert("Additional Cover Update Failed.", "error", 'alert-reprint-update');
                console.error("setReprints api failed", error);
            } finally {
                setReprintUpdating(false);
                setTimeout(() => titleAlert('', 'info', 'alert-reprint-update'), 2000);
            }
        }
    }

    const titleAlert = (message, className = 'info', id) => {
        const statusAlertElement = document.getElementById(id);
        if (statusAlertElement != undefined && statusAlertElement != null) {
            statusAlertElement.textContent = message;
            statusAlertElement.className = className;
        }
    }

    useEffect(() => {
        getListData();
    }, [])

    return (<>
        <div className="accordion-content custom Forecast overflow-visible">
            <Form noValidate="noValidate" >
                <Row className="mt-3">
                    {reprintLoading || reprintUpdating && <PRHLoader></PRHLoader>}
                </Row>
                <div className="reprint-input">
                    <div className="rep-input">
                        <Row className="mt-1 mr-0">
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Cover Qty</Form.Label>
                                    <input type="text" id="formGroupID" className="custom-input left-p-input right-align width80" name="c005_CoverQty" value={formatInputNumber(reprint?.c005_CoverQty) ?? ""} onChange={handleChange} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating} />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group>
                                    <Form.Label >Cover Del Date</Form.Label>
                                    <DatePicker
                                        portalId="root-portal"
                                        className="custom-input right-align left-p-input"
                                        selected={reprint?.c005_CoverDelDate ?? ''}
                                        onChange={(datevalue) => handleChange({
                                            target: {
                                                name: "c005_CoverDelDate",
                                                value: datevalue
                                            }
                                        })}
                                        placeholderText="Select a date"
                                        dateFormat="MM/dd/yyyy"
                                        disabled={
                                            (isNaN(reprint?.c005_CoverQty) || reprint?.c005_CoverQty < 1) || !(!(isNaN(reprint?.c005_PrintBindQty) && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Print/Bind Qty</Form.Label>
                                    <input type="text" max={5000000} min={1} className="custom-input left-p-input right-align width80" autoComplete="off" name="c005_PrintBindQty" value={reprint?.c005_PrintBindQty || ""} onChange={handleChange} disabled={!props.isEditable || reprintLoading || reprintUpdating} />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Print/Bind Date</Form.Label>
                                    <OIDatePicker isdisabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable} name="c005_PrintBindDate"
                                        onInternalChange={handleChange}
                                        externalDate={reprint?.c005_PrintBindDate ?? null}
                                        loading={reprintLoading || reprintUpdating}
                                        ISBNId={props?.metaData?.isbn}
                                        flag={rpntKey}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Sloc</Form.Label>
                                    <select id="formGroupID" className="custom-input left-p-input width80" name="Sloc" onChange={handleChange} value={reprint?.Sloc ?? ''} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating}>
                                        <option value='' disabled>Select SLoc...</option>
                                        {sLocOptions.map((item) => {
                                            return (<option key={item.sloc} value={item.sloc}>{item.sloc}</option>)
                                        })}
                                    </select>
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >New US$</Form.Label>
                                    <input id="formGroupID" type="number" className="custom-input left-p-input right-align width80" name="c005_NewUSPrice" value={reprint?.c005_NewUSPrice ?? ''} onChange={handleChange} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating} />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >New CAN$</Form.Label>
                                    <input id="formGroupID" type="number" className="custom-input left-p-input width80" name="c005_NewCANPrice" value={reprint?.c005_NewCANPrice ?? ''} onChange={handleChange} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating} />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content ">
                                <Form.Group >
                                    <Form.Label >Batch Code</Form.Label>
                                    <select id="formGroupID" className="custom-input left-p-input width80" name="c005_BatchCode" type="number" value={reprint?.c005_BatchCode ?? ''} onChange={handleChange} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating}>
                                        <option value='' disabled>Select Batch...</option>
                                        {BatchCode.map((item) => {
                                            return (<option key={item.batchCode} value={item.batchCode}>{item.batchCode}</option>)
                                        })}
                                    </select>
                                </Form.Group>
                            </Col>
                            <Col md={4} hidden></Col>
                        </Row>
                        <Row className="mt-3 mr-0">
                            <Col md={2} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Comments</Form.Label>
                                    <input id="formGroupID" maxLength={50} className="custom-input left-p-input width180" name="c005_Comments" value={reprint?.c005_Comments ?? ''} onChange={handleChange} disabled={!props.isEditable || reprintLoading || reprintUpdating} />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Version</Form.Label>
                                    <select id="formGroupID" className="custom-input left-p-input width80" name="c005_Version" value={reprint?.c005_Version ?? ''} onChange={handleChange} disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating}>
                                        <option value='' disabled>Select Version...</option>
                                        {VersionOptions.map((item) => {
                                            return (<option key={item.version} value={item.version}>{item.version}</option>)
                                        })}
                                    </select>
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content" title="Changes">
                                <Form.Group >
                                    <Form.Label>CHG</Form.Label><br />
                                    {!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable ?
                                        <input type="checkbox" className="checkbox" name="c005_Changes" checked={reprint?.c005_Changes ?? false} />
                                        :
                                        <input type="checkbox" className="checkbox" name="c005_Changes" value={reprint?.c005_Changes ?? ''} onChange={handleCheckBoxChange} checked={reprint?.c005_Changes ?? false} disabled={reprintLoading || reprintUpdating} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content" title="Hot Print">
                                <Form.Group >
                                    <Form.Label>HP</Form.Label><br />
                                    {!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable
                                        ?
                                        < input type="checkbox" className="checkbox" name="c005_HP" checked={reprint?.c005_HP ?? false} />
                                        :
                                        <input type="checkbox" className="checkbox" name="c005_HP" value={reprint?.c005_HP ?? ''} onChange={handleCheckBoxChange} checked={reprint?.c005_HP ?? false} disabled={reprintLoading || reprintUpdating} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content" title="Reissue">
                                <Form.Group >
                                    <Form.Label >RI</Form.Label><br />
                                    {!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable
                                        ?
                                        <input type="checkbox" className="checkbox" name="c005_RI" checked={reprint?.c005_RI ?? false} />
                                        :
                                        <input type="checkbox" className="checkbox" name="c005_RI" value={reprint?.c005_RI ?? ''} onChange={handleCheckBoxChange} checked={reprint?.c005_RI ?? false} disabled={reprintLoading || reprintUpdating} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content" title="Changes" title="Print Ahead">
                                <Form.Group >
                                    <Form.Label >PA</Form.Label><br />
                                    {!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable
                                        ?
                                        <input type="checkbox" className="checkbox" name="c005_PrintAhead" checked={reprint?.c005_PrintAhead ?? false} />
                                        :
                                        <input type="checkbox" className="checkbox" name="c005_PrintAhead" value={reprint?.c005_PrintAhead} onChange={handleCheckBoxChange} checked={reprint?.c005_PrintAhead ?? false} disabled={reprintLoading || reprintUpdating} />
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={2} className="fit-content srch-mngr">
                                <Form.Group>
                                    <Form.Label>Production Manager</Form.Label><br />
                                    <Typeahead
                                        id="prod-manager"
                                        onChange={onOptionSelect}
                                        options={managerOptions}
                                        onInputChange={() => setselectedOption([])}
                                        placeholder={reprint?.c005_ProductionManager ?? "Search Manager..."}
                                        selected={selectedOption}
                                        disabled={!((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} hidden></Col>
                        </Row>
                    </div>
                    <div className="rep-del">
                        <button type="button" disabled={
                            !((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable || reprintLoading || reprintUpdating} className="deleteReprint del-margin28" onClick={() => setreprintActive(prev => !prev)}>Delete Data</button>
                    </div>
                </div>

                <Row className="mt-3">
                    <Col md={2} className="fit-content">
                        <Form.Group>
                            <Form.Label>Additional Covers/Jackets</Form.Label><br />
                            {
                                !((reprint?.c005_PrintBindQty != null && reprint?.c005_PrintBindQty > 0) || (reprint?.c005_Comments != null && reprint?.c005_Comments != "")) || !props.isEditable
                                    ?
                                    <input type="checkbox" name="c005_AdditionalRow" checked={c005_AdditionalRow ?? false} />
                                    :
                                    <input type="checkbox" name="c005_AdditionalRow" value={c005_AdditionalRow} onChange={handleAdditionalCvrChk} checked={c005_AdditionalRow ?? false} disabled={reprintLoading || reprintUpdating} />
                            }
                        </Form.Group>
                    </Col>
                    <Col md={6} >
                    </Col>
                    <Col md={3}>  <span id="alert-reprint-update"></span></Col>
                </Row>
                {c005_AdditionalRow != null && c005_AdditionalRow ? <><Row>

                    <Col md={2} className="fit-content">
                        <Form.Group >
                            <Form.Label >Cover Qty</Form.Label>
                            <input type="text" onChange={handleAddtionalCVRChange} className="custom-input left-p-input right-align width80" placeholder="" name="c005_CoverQty" value={additionalCVRReprint?.c005_CoverQty || ""} disabled={additionalCVRReprint?.c005_PrintBindQty == null || additionalCVRReprint?.c005_PrintBindQty < 1 || !props.isEditable || reprintLoading || reprintUpdating} />
                        </Form.Group>
                    </Col>
                    <Col md={2} className="fit-content">
                        <Form.Group>
                            <Form.Label >Cover Del Date</Form.Label>
                            <DatePicker
                                portalId="root-portal"
                                popperPlacement="bottom"
                                className="custom-input right-align left-p-input"
                                selected={additionalCVRReprint?.c005_CoverDelDate ?? ''}
                                onChange={(date) => handleAddtionalCVRChange({
                                    target: {
                                        name: "c005_CoverDelDate",
                                        value: date
                                    }
                                })}
                                placeholderText="Select a date"
                                dateFormat="MM/dd/yyyy"
                                disabled={additionalCVRReprint?.c005_CoverQty == null || additionalCVRReprint?.c005_CoverQty <= 0 || !props.isEditable || reprintLoading || reprintUpdating}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2} className="fit-content">
                        <Form.Group >
                            <Form.Label >Print/Bind Qty</Form.Label>
                            <input type="text" max={5000000} onChange={handleAddtionalCVRChange} className="custom-input left-p-input right-align width80" name="c005_PrintBindQty" value={additionalCVRReprint?.c005_PrintBindQty || "1"} disabled={!props.isEditable || reprintLoading || reprintUpdating} />
                        </Form.Group>
                    </Col>
                    <Col md={3} className="fit-content">
                        <Form.Group >
                            <Form.Label >Print/Bind Date</Form.Label>
                            <OIDatePicker isdisabled={!props.isEditable} name="c005_PrintBindDate"
                                onInternalChange={handleAddtionalCVRChange}
                                externalDate={additionalCVRReprint?.c005_PrintBindDate ?? null}
                                loading={reprintLoading || reprintUpdating} flag={addtnlRpntKey} />
                        </Form.Group>
                    </Col>
                </Row>
                    <Row>
                        <Col md={4} className="fit-content">
                            <Form.Group >
                                <Form.Label >Comments</Form.Label>
                                <input id="formGroupID" maxLength={50} onChange={handleAddtionalCVRChange} className="custom-input left-p-input  width180   " name="c005_Comments" value={additionalCVRReprint?.c005_Comments || ''} disabled={!props.isEditable || reprintLoading || reprintUpdating} />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
                    :
                    <></>}
            </Form>
            {reprintActive && <ReprintDelete onClose={onClose} reprintActive={reprintActive} deleteReprint={() => deleteReprint(false)}  ></ReprintDelete>}
            {reprintActiveCVR && <ReprintDelete onClose={onCloseCVR} reprintActive={reprintActiveCVR} deleteReprint={() => deleteReprint(true)}  ></ReprintDelete>}
        </div>
    </>)
}